import { IMoveToProjectParams } from '../types/IMoveToProjectParams';
import { IResult } from '../types/IResponse';
import { Request } from './Request';

export class MoveWorkbooksToProjectRequest extends Request<IMoveToProjectParams, IResult> {
  constructor(params: IMoveToProjectParams) {
    super('moveWorkbooksToProject', params);
  }
}
